<template> <!--https://vuetifyjs.com/en/api/v-input/-->
    <v-text-field
        v-bind:value="value"
        v-on:input="$emit('input', $event)"
        :outlined="outlined"
        :dense="dense"
        :label="label"
        :color="ada.blue"
        :disabled="readOnly || disabled"
        :type="type"
        :loading="loading"
        :required="required"
        :hide-details="hideDetails"
        :error-messages="errorMessages"
        :placeholder="placeholder"
        :hint="hint"
        :persistent-hint="typeof hint !== 'undefined'"
        @blur="$emit('blur', $event)"
        @keyup.enter="$emit('enter')"
    >
        <v-icon v-if="prependIcon"
                slot="prepend"
                :color="prependIconColor"
                @click="$emit('click:prepend')"
        >
            {{ prependIcon }}
        </v-icon>

        <v-icon v-if="appendIcon"
                slot="append"
                :color="appendIconColor"
                @click="$emit('click:append')"
        >
            {{ appendIcon }}
        </v-icon>

        <v-icon v-if="appendOuterIcon"
                slot="append-outer"
                :color="appendOuterIconColor"
                @click="$emit('click:append-outer')"
        >
            {{ appendOuterIcon }}
        </v-icon>
    </v-text-field>
</template>

<script>
import ada from '../../scss/ada_colors.scss';

export default {
    name: "Input",
    props: {
        'value': [String, Number],
        'label': String,
        'readOnly': Boolean,
        'disabled': Boolean,
        'appendIcon': {
            type: String
        },
        'appendIconColor': {
            type: String,
            default: null
        },
        'appendOuterIcon': {
            type: String
        },
        'appendOuterIconColor': {
            type: String,
            default: null
        },
        'prependIcon': {
            type: String
        },
        'hint': {
            type: String
        },
        'prependIconColor': {
            type: String,
            default: null
        },
        'type': {
            type: String,
            default: 'text'
        },
        'outlined': {
            type: Boolean,
            default: false
        },
        'dense': {
            type: Boolean,
            default: false
        },
        'hideDetails': {
            type: [Boolean, String],
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            required: false
        },
        placeholder: String,
        loading: Boolean,
    },
    data: () => {
        return {
            ada
        }
    },
}
</script>

<style scoped>

</style>